export const ORIGIN = {
	QSR: 1,
	LB: 2,
	MOBILE: 3,
	KIOSK: 4,
	ONLINE_STORE: 5,
	PHONE_ORDER: 6,
	EXTERNAL: 7,
	DOORDASH: 8,
	APP: 13,
} as const;
export type TOrigin = typeof ORIGIN[keyof typeof ORIGIN];


// Only exporting the ones we are going to use for now
export const OriginLabels: Record<TOrigin, string> = {
	[ORIGIN.QSR]: 'Cashier',
	[ORIGIN.LB]: 'Line Buster',
	[ORIGIN.MOBILE]: 'Mobile',
	[ORIGIN.KIOSK]: 'Kiosk',
	[ORIGIN.ONLINE_STORE]: 'Online Store',
	[ORIGIN.PHONE_ORDER]: 'Phone',
	[ORIGIN.EXTERNAL]: 'External',
	[ORIGIN.DOORDASH]: 'DoorDash',
	[ORIGIN.APP]: 'Customer Portal App',
} as const;
